import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function HeaderNavigationMobile() {
  const { t } = useTranslation();

  const navLinks = [
    { title: t("home.nav.about"), href: "/about" },
    { title: t("home.nav.news"), href: "/news" },
    // { title: t("home.nav.projects"), href: "/projects" },
    { title: t("home.nav.education"), href: "/educational-materials" },
    // { title: t("home.nav.cooperation"), href: "/cooperation" },
    // { title: t("home.nav.forum"), href: "/forum" },
  ];

  return (
    <nav>
      <ul className="flex flex-col gap-10 text-xl text-text-300 text-right">
        {navLinks.map((link) => (
          <li key={link.title}>
            <Link
              to={link.href}
              className="hover:text-primary-400 transition-colors duration-200"
            >
              {link.title}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}

